import { Breadcrumbs, Link, Typography, makeStyles } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  homeLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    cursor: 'pointer',
    fontWeight: 700,
  },
  homeIcon: {
    fontSize: 18,
  },
  current: {
    fontWeight: 800,
  },
}));

interface MetricsBreadcrumbsProps {
  /** Label for the current page (the active dashboard). */
  currentPage: string;
}

/**
 * Shared breadcrumb navigation for the metrics dashboards.
 *
 * Renders "Metrics Dashboard / <currentPage>" where the first crumb links
 * back to the metrics dashboard home (`/metrics`).
 */
export const MetricsBreadcrumbs = ({ currentPage }: MetricsBreadcrumbsProps) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleHomeClick = (event: MouseEvent) => {
    event.preventDefault();
    navigate('/metrics');
  };

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="metrics breadcrumb"
      className={classes.root}
    >
      <Link
        color="inherit"
        href="/metrics"
        onClick={handleHomeClick}
        className={classes.homeLink}
      >
        <HomeIcon className={classes.homeIcon} />
        Metrics Dashboard
      </Link>
      <Typography color="textPrimary" className={classes.current}>
        {currentPage}
      </Typography>
    </Breadcrumbs>
  );
};
